var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.5762 3.34151C13.9399 3.65973 13.9767 4.21252 13.6585 4.5762L6.65852 12.5762C6.49134 12.7673 6.24942 12.8763 5.99555 12.875C5.74168 12.8737 5.50089 12.7622 5.33567 12.5695L2.33567 9.06945C2.02117 8.70254 2.06366 8.15016 2.43057 7.83566C2.79748 7.52117 3.34987 7.56366 3.66437 7.93057L6.00683 10.6635L12.3415 3.42382C12.6597 3.06014 13.2125 3.02329 13.5762 3.34151Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export default ForwardRef;